import angular from 'angular';

let EmailDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Email) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.email;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete
  });

  activate();

  function activate() {
    clearForm();

    loadResource($ctrl.id);
  }

  function clearForm(form) {
    $ctrl.email = {};

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(email, event) {
    let confirmMessage = 'service-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Email
          .destroy(email)
          .then(response => {
            Toast.success($filter('translate')('email-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('email.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, email) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    save(email);
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Email.show(id)
        .then(response => {
          $ctrl.email = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(email) {
    $ctrl.saving = true;

    Email
      .save(email)
      .then(response => {
        Toast.success($filter('translate')('email-detail-save-success'));
        $ctrl.service = response;
        $ctrl.saving = false;
        $state.go('email.list');
      })
      .catch(err => {
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'email-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

EmailDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Email'];

export default EmailDetailController;



// WEBPACK FOOTER //
// ./client/app/components/email/email-detail.controller.js